var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cashier-page"},[_c('order-list',{attrs:{"type":"underline","hide-menu":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }